export enum AllocationTypes {
    Component = 0,
    FinalAssembly = 1,
    Consolidation = 2,
}

export interface Overview {
    scaniaUnitId: number;
    name: string;
    totalCount: number;
    allocatedCount: number;
    produceCount: number;
    produceCountError: number;
    isCompleted: boolean;
}

export interface AllocationOverviewConfirmationCheck {
    scaniaUnitId: number;
    updatedBy: string;
    isCompleted: boolean;
}

export interface SimulationOverview {
    totalSimulation: number;
    seuSimulation: number;
    slaSimulation: number;
}

export interface MissingPartDetails {
    marketId: number;
    totalCount: number;
    marketName: string;
}

export interface BookClosureDetails {
    id: number;
    fromDate: Date;
    toDate: Date;
    productionDate: Date;
    month:string;
}

export interface SimulationMonthlyData {
    year: number;
    month: number;
    monthName: string;
    totalSimulation: number;
    seuSimulation: number;
    slaSimulation: number;
    errorSimulation: number;
    seuErrorSimulation: number;
    slaErrorSimulation: number;
}

export interface SimulationMonthlyResponse {
    monthlyData: SimulationMonthlyData[];
}

